import PropTypes from "prop-types";
import { useRef, useState } from "react";

import BoardButton from "./BoardButton";
import ButtonTooltip from "./ButtonTooltip";
import DuplicateModal from "./DuplicateModal";

DuplicateButton.propTypes = {
  boardTitle: PropTypes.string,
  boardID: PropTypes.number,
};

export default function DuplicateButton({ boardID, boardTitle }) {
  const buttonRef = useRef();
  const [showTooltip, setShowTooltip] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);

  return (
    <>
      <BoardButton
        className="fad fa-copy"
        onClick={() => setShowDuplicateModal(true)}
        data-cy="duplicateBoardSheetButton"
        ref={buttonRef}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      />
      <ButtonTooltip
        show={showTooltip}
        buttonRef={buttonRef}
        content={`Copy Report`}
      />
      <DuplicateModal
        boardID={boardID}
        boardTitle={boardTitle}
        show={showDuplicateModal}
        setShow={setShowDuplicateModal}
      />
    </>
  );
}
